export const version = "hdnode/5.6.0";
